var _style, _path, _path2, _ellipse, _path3, _circle, _circle2, _circle3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBonk = function SvgBonk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "bonk_svg__CIRCLE_OUTLINE_BLACK",
    width: "1rem",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".bonk_svg__st3{fill:#efb99d}.bonk_svg__st4{fill:#fbfbfb}.bonk_svg__st5{fill:#e72d36}")), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    style: {
      fill: "#fdde00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4 181s-13.2 16.7-8.8 92.2c0 0-28.9 74-19.1 111.8 9.8 37.7 48 35.8 48 35.8s61.3 53.9 108.3 6.4c47.1-47.6-39.2-231.9-39.2-231.9l-10.8-63.7s-11.8 9.3-10.3 70.6-24 18.1-24 18.1z",
    style: {
      fill: "#3c2d0c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.3 247.7-16.2 45.6-5.9 31.9s-20.1 71.1 62.8 70.1c0 0 64.7 57.9 106.9 19.1l11.3-12.3 19.6-30.4 32.4-96.6s-10.3-66.2-75.5-93.6c0 0-5.4-2.9-15.2 1 0 0-27-60.8-44.1-53.4 0 0-14.7 7.8-2 67.7l-23 10.3s-25.2-47.8-48.5-38.2c-21.7 8.7-2.6 78.8-2.6 78.8",
    style: {
      fill: "#e78c19"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m220.1 158.9 2 26.5s1.5 15.2 17.6 9.8c4.6-1.5 8.6-4.7 8.2-9.9-.3-3.9-3-7.5-4.8-10.8-3.3-6.3-6-13-9.9-19.1-2-3.1-6.1-10-10.6-9.2 0 0-3.4-1-2.5 12.7M149.3 188.7c.3-.2 6.9-8.5 20.6 11.7s12.3 17.6 12.3 17.6 7.4 8.1-7.7 18.5c-3.3 2.4-6.9 4.4-10.7 6-2.4.9-4.9 1.4-7.4 1.4-2.9-.1-4.2-1.6-4.9-4.3-2.3-8.8-4.9-17.6-6.2-26.6-1-7-3-19.8 4-24.3",
    className: "bonk_svg__st3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.5 229.4c0 4.8-7 8.7-15.7 8.7s-15.7-3.9-15.7-8.7 7.2-11.9 15.8-11.9 15.6 7.1 15.6 11.9",
    className: "bonk_svg__st4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 208.4,
    cy: 261.5,
    className: "bonk_svg__st4",
    rx: 17.1,
    ry: 11,
    transform: "rotate(-60.495 208.428 261.537)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m240.2 306.7 42.9-22.3s53.4-27.9 66.4-6.4 0 54.4 0 54.4-5.6 38.5-44.9 41.9l-21.1 2.9-27 .7s-43.4 2.5-75.3-21.1l-10.1-12.3s-20.3-27.9-6.1-48 62.8 11 62.8 11 6.8 3.7 12.4-.8",
    className: "bonk_svg__st4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 337.5,
    cy: 185.2,
    r: 10.3,
    className: "bonk_svg__st5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.7,
    cy: 159.9,
    r: 10.3,
    className: "bonk_svg__st5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.2,
    cy: 151.8,
    r: 10.3,
    className: "bonk_svg__st5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M286.3 78.8c2.2 30.4-2.2 57.9-9.6 57.9s-17.2-29.7-17.2-57.9c0-11.6 6.1-13.5 13.5-13.5 7.5 0 12.5 1.9 13.3 13.5M354.5 97.7c-11.2 28.3-27.1 51.2-33.7 48s-2.6-34.2 9.7-59.6c5.1-10.5 11.4-9.5 18-6.3 6.6 3.3 10.3 7.1 6 17.9M403.3 152.9c-24.7 17.9-50.3 28.7-54.2 22.4s16.2-30.2 40.1-45.1c9.9-6.1 14.7-1.9 18.6 4.3 3.8 6.3 4.9 11.5-4.5 18.4",
    className: "bonk_svg__st5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m238.2 276.8-2.7.3c.1.3.2.6.2 1 0 3.1-4.9 5.7-11 5.9 0 .3-.1.5 0 .8.3 3.8 6.9 6.4 14.6 5.8 7.8-.6 13.9-4.2 13.6-8-.4-3.8-6.9-6.4-14.7-5.8M292.4 263.4l-2.7.3c.1.3.2.6.2 1 0 3.1-4.9 5.7-11 5.9 0 .3-.1.5 0 .8.3 3.8 6.9 6.4 14.6 5.8 7.8-.6 13.9-4.2 13.6-8s-6.9-6.4-14.7-5.8M310.2 279.3s-21.5 6.3-20.2 18.4 27.2 18.4 27.2 18.4 7 2.8 11-3.9c4-6.6 9.9-15.6 8.3-28.5 0 0-.5-9.6-26.3-4.4"
  })));
};
export default SvgBonk;